import * as e from "react";
import l from "@appchoose/cn";
import r from "@appchoose/icon";
import * as t from "@radix-ui/react-dialog";
const N = t.Root, x = t.Trigger, d = t.Portal, D = t.Close, n = e.forwardRef(({ className: a, ...o }, s) => /* @__PURE__ */ e.createElement(
  t.Overlay,
  {
    ref: s,
    className: l(
      "fixed inset-0 z-40 bg-black/50 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
      a
    ),
    ...o
  }
));
n.displayName = t.Overlay.displayName;
const c = e.forwardRef(({ className: a, children: o, ...s }, i) => /* @__PURE__ */ e.createElement(d, null, /* @__PURE__ */ e.createElement(n, null), /* @__PURE__ */ e.createElement(
  t.Content,
  {
    ref: i,
    className: l(
      "bg-background fixed left-[50%] top-[50%] z-50 grid w-full max-w-lg translate-x-[-50%] translate-y-[-50%] gap-4 border p-6 shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] sm:rounded-lg",
      a
    ),
    ...s
  },
  o,
  /* @__PURE__ */ e.createElement(t.Close, { className: "ring-offset-background focus:ring-ring data-[state=open]:bg-accent data-[state=open]:text-muted-foreground absolute right-4 top-4 rounded-sm opacity-70 transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:pointer-events-none" }, /* @__PURE__ */ e.createElement(r, { icon: "close" }), /* @__PURE__ */ e.createElement("span", { className: "sr-only" }, "Close"))
)));
c.displayName = t.Content.displayName;
const m = ({
  className: a,
  ...o
}) => /* @__PURE__ */ e.createElement(
  "div",
  {
    className: l(
      "flex flex-col space-y-1.5 text-center sm:text-left",
      a
    ),
    ...o
  }
);
m.displayName = "DialogHeader";
const f = ({
  className: a,
  ...o
}) => /* @__PURE__ */ e.createElement(
  "div",
  {
    className: l(
      "flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2",
      a
    ),
    ...o
  }
);
f.displayName = "DialogFooter";
const p = e.forwardRef(({ className: a, ...o }, s) => /* @__PURE__ */ e.createElement(
  t.Title,
  {
    ref: s,
    className: l(
      "text-lg font-semibold leading-none tracking-tight",
      a
    ),
    ...o
  }
));
p.displayName = t.Title.displayName;
const g = e.forwardRef(({ className: a, ...o }, s) => /* @__PURE__ */ e.createElement(
  t.Description,
  {
    ref: s,
    className: l("text-muted-foreground text-sm", a),
    ...o
  }
));
g.displayName = t.Description.displayName;
export {
  N as Dialog,
  D as DialogClose,
  c as DialogContent,
  g as DialogDescription,
  f as DialogFooter,
  m as DialogHeader,
  n as DialogOverlay,
  d as DialogPortal,
  p as DialogTitle,
  x as DialogTrigger
};
